<template>
  <div class="bottom-nav">
    <div 
      v-for="item in tabList" 
      :key="item.id" 
      :class="['nav-item', { active: item.id === tabId }]" 
      @click="onTab(item.id)"
    >
      <div class="icon-container">
        <svg 
          class="nav-icon" 
          :viewBox="`0 0 24 24`" 
          fill="none" 
          stroke="currentColor" 
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path v-if="item.id === 0" d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z M9 22v-8h6v8"/>
          <path v-else-if="item.id === 1" d="M21 5H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 13H3V7h18v11z M8 10h8v2H8z"/>
          <path v-else d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"/>
        </svg>
      </div>
      <span class="nav-label">{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
const TAB_LIST = [
  { id: 0, name: "首页", page: "/plaza" },
  { id: 1, name: "钱包", page: "/wallet" },
  { id: 2, name: "我的", page: "/user" },
]

export default {
  name: 'NavBottom',
  props: {
    tabId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      tabList: TAB_LIST,
    }
  },
  methods: {
    onTab(tabId) {
      const tabItem = this.tabList[tabId]
      this.$router.push(tabItem.page)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: calc(56px + env(safe-area-inset-bottom));
  padding-bottom: max(8px, env(safe-area-inset-bottom));
  background: linear-gradient(to top, rgba(255, 255, 255, 0.98), rgba(255, 255, 255, 1));
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(10px);
  z-index: 99;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  flex: 1;
  height: 100%;
  cursor: pointer;
  position: relative;
  transition: all 0.28s cubic-bezier(0.34, 1.56, 0.64, 1);
  color: #a0a8b4;
  user-select: none;
  padding: 0 8px;

  .icon-container {
    position: relative;
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    transition: all 0.28s cubic-bezier(0.34, 1.56, 0.64, 1);
    background: transparent;
  }

  .nav-icon {
    width: 20px;
    height: 20px;
    transition: all 0.28s cubic-bezier(0.34, 1.56, 0.64, 1);
    color: currentColor;
  }

  .nav-label {
    font-size: 10px;
    font-weight: 500;
    white-space: nowrap;
    transition: all 0.28s cubic-bezier(0.34, 1.56, 0.64, 1);
    letter-spacing: 0.2px;
  }

  // 未激活状态的悬停效果
  &:hover:not(.active) {
    color: #7a8290;

    .icon-container {
      background: rgba(122, 130, 144, 0.08);
      transform: scale(1.05);
    }
  }

  // 激活状态
  &.active {
    color: #2563eb;

    .icon-container {
      background: linear-gradient(135deg, rgba(37, 99, 235, 0.15), rgba(59, 130, 246, 0.1));
      transform: scale(1.1);
      box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
    }

    .nav-icon {
      filter: drop-shadow(0 2px 4px rgba(37, 99, 235, 0.3));
      animation: iconPop 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    .nav-label {
      font-weight: 600;
      animation: labelSlide 0.3s ease-out;
    }
  }
}

@keyframes iconPop {
  0% {
    transform: scale(0.7) translateY(4px);
  }
  50% {
    transform: scale(1.15);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes labelSlide {
  0% {
    transform: translateY(4px);
    opacity: 0.6;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
